"use client"

import Link from "next/link"
import { useState } from "react"
import { Menu, X } from "lucide-react"
import Image from "next/image"

export function Navigation() {
  const [isOpen, setIsOpen] = useState(false)

  const links = [
    { href: "/", label: "Home" },
    { href: "/about", label: "About Us" },
    { href: "/team", label: "Our Team" },
    { href: "/blog", label: "Blog" },
    { href: "/gallery", label: "Gallery" },
    { href: "/contact", label: "Contact" },
  ]

  const ctaLinks = [
    { href: "/become-member", label: "Become a Member", variant: "primary" },
    { href: "/become-sponsor", label: "Become a Sponsor", variant: "secondary" },
  ]

  return (
    <nav className="sticky top-0 z-50 bg-background border-b border-border shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link href="/" className="flex items-center gap-2">
            <Image
              src="/main_logo.png"
              width={32}
              height={32}
              alt="Logo"
              className="w-8 h-8 rounded-lg flex items-center justify-center"
            />
            <span className="hidden sm:inline font-semibold text-foreground">Let me be a child</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-1">
            {links.map((link) => (
              <Link
                key={link.href}
                href={link.href}
                className="px-3 py-2 text-sm font-medium text-foreground hover:text-primary transition-colors"
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Desktop CTA Buttons */}
          <div className="hidden md:flex items-center gap-2">
            <Link
              href="/become-member"
              className="px-4 py-2 rounded-lg text-sm font-medium  border-primary text-primary hover:bg-muted hover:text-primary transition-colors"
            >
              Become a Member
            </Link>
            <Link
              href="/become-sponsor"
              className="px-4 py-2 rounded-lg text-sm font-medium bg-primary text-primary-foreground hover:opacity-90 transition-opacity"
            >
              Sponsor a Child
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button className="md:hidden p-2" onClick={() => setIsOpen(!isOpen)} aria-label="Toggle menu">
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden pb-4 border-t border-border">
            <div className="space-y-2 py-4">
              {links.map((link) => (
                <Link
                  key={link.href}
                  href={link.href}
                  className="block px-4 py-2 text-foreground hover:text-primary transition-colors"
                  onClick={() => setIsOpen(false)}
                >
                  {link.label}
                </Link>
              ))}
              <div className="px-4 py-2 space-y-2">
                <Link
                  href="/become-member"
                  className="block w-full px-4 py-2 rounded-lg text-center bg-primary text-primary-foreground text-sm font-medium hover:opacity-90 transition-opacity"
                  onClick={() => setIsOpen(false)}
                >
                  Become a Member
                </Link>
                <Link
                  href="/become-sponsor"
                  className="block w-full px-4 py-2 rounded-lg text-center border border-primary text-primary text-sm font-medium hover:bg-primary hover:text-primary-foreground transition-colors"
                  onClick={() => setIsOpen(false)}
                >
                  Sponsor a Child
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  )
}
